import * as constActions from './DeviceControlConstActions';
import initialState from './DeviceControlInitialState';

export default function DeviceControlReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.GET_DEVICE_CONTROL_COLUMNS_REQUEST: {
      return state;
    }

    case constActions.GET_DEVICE_CONTROL_COLUMNS_SUCCESS: {
      return Object.assign({}, state, {
        columns: action.results
      });
    }

    case constActions.GET_DEVICE_CONTROL_COLUMNS_FAILURE: {
      return state;
    }

    case constActions.GET_DEVICE_CONTROL_REQUEST: {
      return state;
    }

    case constActions.GET_DEVICE_CONTROL_FAILURE: {
      return state;
    }

    case constActions.GET_INITIAL_DEVICE_CONTROL_SUCCESS: {
      return Object.assign({}, state, {
        results: [...action.results]
      });
    }

    case constActions.GET_DEVICE_CONTROL_SUCCESS: {
      return Object.assign({}, state, {
        results: [...state.results, ...action.results]
      });
    }

    case constActions.SAVE_DEVICE_CONTROL_SEARCH_PARAMETERS: {
      return Object.assign({}, state, {
        parameters: action.parameters
      });
    }

    case constActions.SELECT_DEVICE_CONTROL_SUCCESS: {
      return Object.assign({}, state, {
        selectedDeviceControl: action.selectedDeviceControl
      });
    }

    case constActions.SELECT_ALL_DEVICE_CONTROL_SUCCESS: {
      return Object.assign({}, state, {
        isSelectAllChecked: action.isSelectAllChecked
      });
    }

    default:
      return state;
  }
}
